import { type UniversalDrawerFieldConfig } from './types';

/** Clause keys a drawer row stores its value under. */
export function getOwnedFieldKeys(
  fieldConfig: UniversalDrawerFieldConfig,
): readonly [string, ...string[]] {
  return fieldConfig.input === 'custom' && fieldConfig.fields
    ? fieldConfig.fields
    : [fieldConfig.field];
}
